import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { dynamicRoutes } from "../../../../Routes";
import { withApollo } from "react-apollo";
// Externals
import classNames from "classnames";
import PropTypes from "prop-types";
import contents from "../../../../language";

// Material helpers
import { withStyles } from "@material-ui/core";
import {
  ExpandLess,
  ExpandMore,
  // DashboardOutlined as Dashboard,
  // PersonOutlined as ProfileIcon,
  Settings,
  Category,
  ShoppingBasket,
  ShoppingCart
} from "@material-ui/icons";

// Material components
import {
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse
} from "@material-ui/core";

// Component styles
import styles from "./styles";

const Sidebar = ({ classes, className, language, direction, client }) => {
  const rootClassName = classNames(classes.root, className);
  const menuItems = [
    {
      id: "1",
      name: contents["sidebar.setting"][language || "en"],
      des: "setting",
      icon: Settings,
      path: "/dashboard"
    },
    {
      id: "2",
      name: contents["sidebar.category"][language || "en"],
      des: "category",
      icon: Category,
      path: "/dashboard"
    },
    {
      id: "3",
      name: contents["sidebar.product"][language || "en"],
      des: "product",
      icon: ShoppingBasket,
      path: "/dashboard"
    },
    {
      id: "4",
      name: contents["sidebar.commercial-report"][language || "en"],
      des: "commercial-report",
      icon: ShoppingCart,
      path: "/dashboard"
    }
  ];
  const [flag, setFlag] = React.useState(true);
  const [open, setOpen] = React.useState({
    "1": false,
    "2": false,
    "3": false,
    "4": false
  });

  const [selectedSub, setSelectedSub] = useState(null);

  // console.log(selectedSub);

  function handleClick(i) {
    open[i] = !open[i];
    setOpen(open);
    setFlag(!flag);
  }

  const handleClasses = el => {
    let itemClasses = [];
    if (direction === "rtl") {
      selectedSub === el.path
        ? itemClasses.push(classes.listItem, classes.rtlSelectedItem)
        : itemClasses.push(classes.listItem);
    } else {
      selectedSub === el.path
        ? itemClasses.push(classes.listItemLtr, classes.ltrSelectedItem)
        : itemClasses.push(classes.listItemLtr);
    }
    return itemClasses;
  };

  const routes = dynamicRoutes(language);

  // console.log(direction, language, "sidebar");

  return (
    <nav style={{ height: "auto" }} className={rootClassName}>
      <div className={classes.logoWrapper}>
        <Link className={classes.logoLink} to="/">
          <img
            alt="Genomin"
            className={classes.logoImage}
            src="/images/logos/Atlantis.png"
          />
        </Link>
      </div>
      <Divider className={classes.logoDivider} />
      <List
        disablePadding
        component="nav"
        aria-labelledby="nested-list-subheader"
        className={classes.root}
      >
        {menuItems.map((item, i) => (
          <div key={i}>
            <ListItem
              button
              onClick={() => handleClick(item.id)}
              className={
                direction === "rtl" ? classes.listItem : classes.listItemLtr
              }
            >
              <ListItemIcon>
                <item.icon />
              </ListItemIcon>
              <ListItemText primary={item.name} />
              {open[item.id] ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open[item.id]} timeout="auto" unmountOnExit>
              {routes.map((el, i) => {
                return el.sub === item.des ? (
                  <NavLink to={el.path} key={i}>
                    <ListItem
                      activeclassname={classes.activeListItem}
                      className={handleClasses(el)}
                      onClick={() => setSelectedSub(el.path)}
                    >
                      <ListItemIcon>
                        <el.icon />
                      </ListItemIcon>
                      <ListItemText
                        classes={{ primary: classes.listItemText }}
                        primary={el.name}
                      />
                    </ListItem>
                  </NavLink>
                ) : null;
              })}
            </Collapse>
          </div>
        ))}
      </List>
    </nav>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
};

export default withApollo(withStyles(styles)(Sidebar));
